<template>
    <div>
        <div class="page-main">
            <div class="top">
                <img src="./images/topImg.png" alt="" />
                <img src="./images/cloud_left.png" class="cloud_left" alt="" />
                <img
                    src="./images/cloud_right.png"
                    class="cloud_right"
                    alt=""
                />
            </div>
            <div class="rluesWrap">
                <img src="./images/rule_circle.png" class="circle" alt="" />
                <!-- 活动规则img -->
                <img src="./images/rules.png" class="rules" alt="" />
                <img src="./images/cules_coins.png" class="coins" alt="" />
                <img src="./images/rules_he.png" class="he" alt="" />
                <img src="./images/rule_circle.png" class="circle_two" alt="" />
            </div>
            <div class="gitWrap">
                <img src="./images/act_gifts.png" alt="" />
                <img src="./images/act_he.png" class="he" alt="" />
                <img src="./images/act_cj.png" class="cj" alt="" />
                <img src="./images/act_gifticon.png" class="gift" alt="" />
                <img
                    src="./images/act_smallicon.png"
                    class="smallicon"
                    alt=""
                />
                <img src="./images/act_bigicon.png" class="bigicon" alt="" />
            </div>
            <!-- 这这这 -->
            <!-- <div class="free-short"></div> -->
            <div class="search">
                <input
                    type="text"
                    placeholder="搜索编号"
                    v-model="votenum"
                    class="ipt"
                />
                <img
                    src="./images/searchIcon.png"
                    class="searchicon"
                    @click="getData"
                    alt=""
                />
            </div>
            <div class="worksWrap">
                <img src="./images/worksTitle.png" alt="" />
                <div class="worksDetail">
                    <div
                        class="worksBg"
                        v-for="(item, index) in bgArr"
                        :key="index"
                    >
                        <img
                            src="./images/works_bg.png"
                            class="works_bg"
                            alt=""
                        />
                    </div>
                    <div class="detailWrap">
                        <div
                            class="detail"
                            v-for="(item, index) in voteList"
                            :key="index"
                        >
                            <div class="votedetail">
                                <div class="pic">
                                    <div class="picarea">
                                        <img
                                            :src="JSON.parse(item.picUrl).m"
                                            class="worksPic"
                                            @click="show(item)"
                                            alt=""
                                        />
                                    </div>
                                </div>
                                <div class="vote">
                                    <div class="num">
                                        <p class="left">NO.{{ index + 1 }}</p>
                                        <p class="right">
                                            编号：{{ item.extendData }}
                                        </p>
                                    </div>
                                    <div class="num">
                                        <p class="left">
                                            昵称：{{
                                                item.userInfo &&
                                                item.userInfo.nickName.length >
                                                    7
                                                    ? item.userInfo.nickName.substring(
                                                          0,
                                                          7
                                                      ) + '..'
                                                    : item.userInfo.nickName
                                            }}
                                        </p>
                                        <p class="right">
                                            票数：{{ item.voteCount || 0 }}
                                        </p>
                                    </div>
                                </div>
                                <div class="edit">
                                    <img
                                        :src="
                                            (item.userInfo.picUrls &&
                                                JSON.parse(
                                                    item.userInfo.picUrls
                                                ).o) ||
                                                defaultPic
                                        "
                                        class="usericon"
                                        alt=""
                                    />
                                    <div class="btn" @click="addvote(item.id)">
                                        <p>投 票</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bottom">
                <!-- <img src="./images/bottom_pic.png" style='display: block' alt=""> -->
                <img src="./images/bottom_one.png" class="relicone" alt="" />
                <img src="./images/bottom_two.png" class="relictwo" alt="" />
                <img src="./images/bottom_cloud.png" class="cloudone" alt="" />
                <img
                    src="./images/bottom_cloudoutter.png"
                    class="cloudtwo"
                    alt=""
                />
            </div>
            <div class="uploadWrap" v-if="enableUpload">
                <img
                    src="./images/upload_btn.png"
                    class="upload_btn"
                    @click="add"
                    alt=""
                />
                <input
                    name="files"
                    ref="uploadInput"
                    @change="uploadFiles"
                    class="btn"
                    accept="image/*"
                    type="file"
                    multiple
                />
            </div>
            <div class="make-short">
                <a href="https://act.ywbjchina.com/custom-t-shirt">
                    <img
                        src="./images/makeshort.png"
                        class="upload_btn"
                        alt=""
                    />
                </a>
            </div>
        </div>
        <div class="mask" v-if="maskShow">
            <div class="manstips">
                <img src="./images/maskIcon.png" class="maskIcon" alt="" />
                <img
                    src="./images/use_icon.png"
                    class="use_icon"
                    @click="download"
                    alt=""
                />
            </div>
            <img
                src="./images/closeIcon.png"
                class="closeicon"
                @click="close"
                alt=""
            />
        </div>
        <div class="picShow" @click="picisshow = false" v-if="picisshow">
            <img :src="originUrl" class="origin" alt="" />
        </div>
        <div class='picShow' @click='picisshow = false' v-if='picisshow'>
            <img :src="originUrl" class='origin' alt="">
        </div>
    </div>
</template>

<script>
import http from '@http';
import store from '@common/store';
import types from '@common/store/system/types';
import $bridge from '@common/bridge';
import services from './services';
import wxShare from '@utils/wxShare';
import * as imageConversion from 'image-conversion';
export default {
    data() {
        return {
            defaultPic: require('./images/default.png'),
            detailArr: [],
            voteList: [],
            picUrl: '',
            bgNum: 0,
            bgArr: [],
            maskShow: false,
            votenum: '',
            originUrl: '',
            picisshow: false,
            canvote: false,
            enableUpload: true,
        };
    },
    mounted() {
        //this.mockLogin();
        this.enableUpload = !$bridge.isApp;
        this.getData();
        wxShare({
            title: 'T-show投票 C位出道',
            desc: '千元现金大奖和China joy门票，等你来拿',
            link: `${location.origin}/votepage`,
            imgUrl: 'http://wwj.jijiagames.com/web/act/20200715/share.jpg',
        });
    },
    methods: {
        mockLogin() {
            // 15950025010
            services
                .mockLogin({
                    mobilePhone: '13121107673',
                })
                .then((res) => {
                    store.dispatch(types.authorization, res.data.token || '');
                    this.getData();
                });
        },
        uploadFiles(data) {
            imageConversion
                .compressAccurately(data.target.files[0], 500)
                .then((data) => {
                    //The res in the promise is a compressed Blob type (which can be treated as a File type) file;
                    console.log(data);
                    this.uploadImg(data);
                });
        },

        uploadImg(blob) {
            const formData = new FormData();
            const axios = http();
            formData.append('file', blob);
            services
                .getUploadTokenUrl({
                    scenario: 'votepage',
                })
                .then((res) => {
                    if (res.data.uploadPath) {
                        formData.append('appid', res.data.appId);
                        formData.append('scenario', 'springfes');
                        formData.append('thumbnail', res.data.thumbnail || '');
                        formData.append('timestamp', res.data.timestamp);
                        formData.append('token', res.data.token);
                        formData.append('uid', res.data.uid);
                        formData.append('watermark', res.data.watermark || '');
                        axios
                            .post(res.data.uploadPath, formData, {
                                baseURL: '/',
                                method: 'post',
                                headers: {
                                    'Content-Type': 'multipart/form-data',
                                },
                            })
                            .then((response) => {
                                const imgarr = {};
                                for (
                                    let i = 0;
                                    i < response.data.img_urls.length;
                                    i++
                                ) {
                                    if (
                                        response.data.img_urls[i].sizetype ===
                                        'original'
                                    ) {
                                        imgarr.o =
                                            response.data.img_urls[i].url;
                                    }
                                    if (
                                        response.data.img_urls[i].sizetype ===
                                        'L'
                                    ) {
                                        imgarr.l =
                                            response.data.img_urls[i].url;
                                    }
                                    if (
                                        response.data.img_urls[i].sizetype ===
                                        'M'
                                    ) {
                                        imgarr.m =
                                            response.data.img_urls[i].url;
                                    }
                                    if (
                                        response.data.img_urls[i].sizetype ===
                                        'S'
                                    ) {
                                        imgarr.s =
                                            response.data.img_urls[i].url;
                                    }
                                }
                                this.picUrl = imgarr;
                                this.add();
                            });
                    }
                });
        },
        getData() {
            const params = {
                pageSize: 100,
                pageIndex: 1,
                activityId: 14,
                number: this.votenum,
            };
            services.getList(params).then((res) => {
                this.voteList = res.data.list || [];
                if (this.voteList) {
                    this.bgArr = [];
                    this.bgNum = Math.ceil(this.voteList.length / 2);
                    for (let i = 0; i < this.bgNum; i++) {
                        this.bgArr.push({});
                    }
                }
            });
        },
        add() {
            if (!this.picUrl) {
                this.$toastMessage('请先选择');
                return;
            }
            const params = {
                activityId: 14,
                title: 'Tshirt 投票',
                picUrl: JSON.stringify(this.picUrl),
            };
            console.log('add -> params', this.picUrl, params);
            services.actAdd(params).then((res) => {
                console.log('add -> res', res);
                if (res.returnCode != 0) {
                    this.$toastMessage(res.returnMessage);
                    return;
                }
                this.getData();
                this.$toastMessage('活动参加成功,等待审核！');
            });
        },
        addvote(data) {
            if (!this.canvote) {
                setTimeout(() => {
                    this.voteserveice(data);
                }, 500);
            } else {
                this.voteserveice(data);
            }
        },
        voteserveice(data) {
            this.canvote = true;
            const params = {
                activityId: 14,
                activityDetailId: data,
                voteCount: 1,
            };
            services.vote(params).then((res) => {
                if (res.returnCode != 0) {
                    this.$toastMessage(res.returnMessage);
                    this.maskShow = true;
                    this.canvote = false;
                    return;
                }
                this.canvote = false;
                this.getData();
                this.$toastMessage('投票成功');
            });
        },

        download() {
            window.location.href =
                'https://a.app.qq.com/o/simple.jsp?pkgname=com.sdo.qihang.wenbo';
        },
        close() {
            this.maskShow = false;
        },
        show(data) {
            this.originUrl = JSON.parse(data.picUrl).o;
            this.picisshow = true;
        },
    },
};
</script>

<style lang="stylus" scoped>
@keyframes leftShow
    from {
        left -2rem
        opacity 0
    }
    to {
        left 1.3rem
        opacity 1
    }

@keyframes rightShow
    from {
        right -2rem
        opacity 0
    }
    to {
        right 0.4rem
        opacity 1
    }

@keyframes airanimate
    0%
        bottom 0.1rem
    50%
        bottom -0.1rem
    100%
        bottom 0.1rem
#app
    width 100%
    height 100%
.page-main
    width 100%
    overflow hidden
    background-color #0f1036
    .uploadWrap
        width 1.2rem
        height 1rem
        position fixed
        right 0
        top 10rem
        z-index 100
        .btn
            width 1.2rem
            height 1.2rem
            opacity 0
            position absolute
            top 0.2rem
    .make-short
        width 1.2rem
        height 1rem
        position fixed
        right 0
        top 8.7rem
        z-index 100
    .top
        position relative
        width 100%
        .cloud_left
            position absolute
            top 4.5rem
            left 1.3rem
            z-index 100
            animation: leftShow 1.5s linear;
        .cloud_right
            position absolute
            top 2.5rem
            right 0.4rem
            z-index 100
            animation: rightShow 1.5s linear;
    .rluesWrap
        width 100%
        position relative
        top -1.9rem
        display flex
        flex-direction row
        align-items center
        justify-content center
        .circle
            position absolute
            top 0
            left 0
        .rules
            z-index 10
            padding-top 0.2rem
        .coins
            width 100%
            position absolute
            bottom -0.7rem
            z-index 11
        .he
            position absolute
            top -0.3rem
            z-index 12
            right 6%
        .circle_two
            position absolute
            bottom -2rem
            right 0
            transform rotate(180deg)
    .gitWrap
        width 100%
        position relative
        top -1.2rem
        display flex
        flex-direction row
        align-items center
        justify-content center
        .he
            position absolute
            left 0
            top -0.6rem
        .cj
            position absolute
            right 0.4rem
            top 0.1rem
        .gift
            position absolute
            right 0
            top 1.2rem
        .smallicon
            position absolute
            right 1.3rem
            top 1.6rem
            z-index 10
        .bigicon
            position absolute
            left 0
            bottom -.5rem





    .search
        width 100%
        height 0.6rem
        position relative
        z-index 100
        margin-top -0.5rem
        .ipt
            position absolute
            width 90%
            height 100%
            margin-left 5%
            border-radius 1rem
            padding-left .3rem
            font-size 0.28rem
            color #999999
            background-color #fff
        .searchicon
            position absolute
            right 0.5rem
            top 0.05rem
    .worksWrap
        width 100%
        position relative
        display flex
        flex-direction column
        align-items center
        justify-content center
        .worksDetail
            width 6.9rem
            position relative
            display flex
            flex-direction row
            justify-content space-around
            flex-wrap wrap
            .worksBg
                width 6.9rem
                height 5.2rem
                display flex
                flex-direction column
                justify-content center
            .detailWrap
                width 6.9rem
                position absolute
                display flex
                flex-direction row
                justify-content space-around
                flex-wrap wrap
                .detail
                    width 2.8rem
                    height 5.2rem
                    z-index 100
                    display flex
                    flex-direction row
                    flex-wrap wrap
                    .votedetail
                        width 100%
                        height 4.2rem
                        margin-top 0.58rem
                        .pic
                            width 2.8rem
                            height 2.8rem
                            display flex
                            flex-direction row
                            align-items center
                            justify-content center
                            margin-bottom 0.05rem
                            .picarea
                                width 100%
                                height 100%
                                overflow hidden
                                display flex
                                flex-direction row
                                align-items center
                                justify-content center
                                border-radius 0.2rem
                                .worksPic
                                    width 100%
                                    border-radius 0.2rem
                        .vote
                            width 100%
                            margin-left 0.2rem
                            .num
                                width 100%
                                height 0.3rem
                                display flex
                                flex-direction row
                                .left
                                    font-size 0.18rem
                                    color #e4e0ff
                                    width 1.7rem
                                .right
                                    font-size 0.18rem
                                    color #e4e0ff
                        .edit
                            width 100%
                            display flex
                            flex-direction row
                            align-items center
                            padding 0 0.2rem
                            justify-content space-between
                            .usericon
                                width 0.54rem
                                height 0.54rem
                                border-radius 50%
                            .btn
                                width 0.96rem
                                height 0.27rem
                                border-radius 0.1rem
                                background-color #e5801d
                                p
                                    font-size 0.16rem
                                    color #fff
                                    opacity 0.75
                                    display flex
                                    flex-direction row
                                    align-items center
                                    justify-content center
    .bottom
        width 100%
        height 2.6rem
        position relative
        margin-top 0.3rem
        .cloudone
            position absolute
            top 0
            left 0
        .cloudtwo
            width 100%
            position absolute
            bottom 0
            left 0
        .relicone
            left 44%
            position absolute
            animation: airanimate 4s infinite;
        .relictwo
            right -3%
            z-index 100
            position absolute
            animation: airanimate 6s infinite;
.mask
    width 100%
    height 100%
    position fixed
    top 0
    left 0
    right 0
    bottom 0
    background-color rgba(0, 0, 0, .8)
    z-index 100
    display flex
    flex-direction column
    align-items center
    justify-content center
    .manstips
        width 100%
        height 4.3rem
        display flex
        flex-direction row
        align-items center
        justify-content center
        position relative
        .maskIcon
            position absolute
        .use_icon
            position absolute
            bottom 0.1rem
    .closeicon
        margin-top 0.3rem
.picShow
    width 100%
    height 100%
    position fixed
    display flex
    flx-direction row
    align-items center
    justify-content center
    top 0
    left 0
    right 0
    left 0
    background-color rgba(0, 0, 0, 0.7)
    z-index 1000
    .origin
        width 100%
        hight 100%
</style>
